import { config } from "../config";

const apiConfig = {
  baseUrl: config.apiBaseUrl,
};

export default apiConfig;
